module.exports = __webpack_public_path__ + "img/reg_banner.6726291f.jpg";